<template>
  <div>
    <div class="col-lg-3">
      <base-button
          
          style="font-size: 18px"
          @click="getBack()"
          class="btn-link btn-primary"
        >
          &lt; Return to Job List
        </base-button>

      <!-- <p
        style="cursor: pointer; color: #358CCB; font-size: 18px"
        @click="getBack()"
      >
        &lt; Return to Job List
      </p> -->
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-12">
        <simple-wizard ref="tabs" :indextghrunning="huhuhaha" :totalstep="hoi">
          <template slot="header">
            <h2 class="card-title"></h2>
            <h3 class="description"></h3>
          </template>

          <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step1')"
          >
            <template slot="label">
              1
              <p style="color: #A5A5A5">ANF</p>
            </template>
            <first-step
              @my-event="myFunction"
              ref="step1"
              @on-validated="onStepValidated"
            ></first-step>
          </wizard-tab>

          <!-- <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step2')"
          >
            <template slot="label">
              2
              <p style="color: #A5A5A5; width: 200px">WDR</p>
            </template>
            <second-step
            @my-event="myFunction"
              ref="step2"
              @on-validated="onStepValidated"
            ></second-step>
          </wizard-tab> -->

          <!-- <wizard-tab
            :before-change="() => validateStep('step3')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              3
              <p style="color: #A5A5A5; width: 200px">Declaration</p>
            </template>
            <third-step
            @my-event="myFunction"
              ref="step3"
              @on-validated="onStepValidated"
            ></third-step>
          </wizard-tab> -->

        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from "../Vessel/Job/ANF.vue";
import SecondStep from "../Vessel/Job/WDR.vue";
import ThirdStep from "../Vessel/Job/Declaration.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";

export default {
  data() {
    return {
      wizardModel: {},
      activeTabIndex: 0,
      huhuhaha: 0,
      hoi: 0
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    // FourthStep,
    // FifthStep,
    // SixthStep,
    SimpleWizard,
    WizardTab,
  },
  methods: {
    myFunction(e) {
      
    
      let index = parseInt(e.step);

     
     

      if (e.direction == "depan") {
        if (e.step == "1") {
          
          setTimeout(() => {
            
            this.$refs.tabs.tabs[index -1].active = true;
            this.$refs.tabs.tabs[index - 1].checked = true;
            this.huhuhaha = parseInt(e.step)
            this.hoi = 1
          }, 100);
        }
      } 
      if (e.direction == "blkg") {
        if (e.step == "1") {
          this.getBack();
        }

        // if (e.step == "2") {
        //   this.$refs.tabs.tabs[index - 2].active = true;
        //   this.$refs.tabs.tabs[index - 2].checked = false;
        //   this.$refs.tabs.tabs[index - 1].active = false;
        //   this.$refs.tabs.tabs[index - 1].checked = false;
        //   this.$refs.tabs.tabs[index].active = false;
        //   this.$refs.tabs.tabs[index].checked = false;
        //   this.$emit(
        //     "tab-change",
        //     this.$refs.tabs.tabs[index - 1],
        //     this.$refs.tabs.tabs[index]
        //   );
        //   this.huhuhaha = parseInt(e.step) - 2
        //   let newValue = index + 1;
        //   this.$emit("update:startIndex", newValue);
        // }

        // if (e.step == "3") {
        //   this.$refs.tabs.tabs[index - 3].active = true;
        //   this.$refs.tabs.tabs[index - 3].checked = false;
        //   this.$refs.tabs.tabs[index - 2].active = false;
        //   this.$refs.tabs.tabs[index - 2].checked = false;
        //   this.$refs.tabs.tabs[index - 1].active = false;
        //   this.$refs.tabs.tabs[index - 1].checked = false;
        //   this.$refs.tabs.tabs[index].active = false;
        //   this.$refs.tabs.tabs[index].checked = false;
        //   this.$emit(
        //     "tab-change",
        //     this.$refs.tabs.tabs[index - 1],
        //     this.$refs.tabs.tabs[index]
        //   );
        //   this.huhuhaha = parseInt(e.step) - 2
        //   let newValue = index + 1;
        //   this.$emit("update:startIndex", newValue);
        // }
      }
    },
    getBack() {
      sessionStorage.removeItem('datasubmitted');
      this.$router.push("/Vessel/Request");
    },
    validateStep(ref) {
      console.log(ref);
      return this.$refs[ref].validate();
    },
    validate(tab) {
      let tabToValidate = tab || this.activeTab;
      console.log(this.activeTab);
      let beforeChange = tabToValidate.beforeChange;
      if (beforeChange) {
        return Promise.resolve(beforeChange())
          .then((res) => {
            this.activeTab.hasError = res ? false : true;
            return res;
          })
          .catch(() => {
            this.activeTab.hasError = true;
          });
      } else {
        return Promise.resolve(true);
      }
    },
    onStepValidated(validated, model) {
      console.log(validated);
      console.log(model);
      this.wizardModel = { ...this.wizardModel, ...model };
      console.log(this.wizardModel);

      // console.log(model)
      // console.log(this.wizardModel)
    },
    wizardComplete() {
      swal("Good job!", "You clicked the finish button!", "success");
    },
  },
  created(){
    
  }
};
</script>

<!-- <template>
  <div>
    <div class="col-lg-2">
      <p style="cursor: pointer; color: #358CCB; font-size: 18px" @click="getBack()">&lt; Return Home</p>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-12">
        <simple-wizard>
          <template slot="header">
            <h2 class="card-title"></h2>
            <h3 class="description"></h3>
          </template>

          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label">
              1
              <p style="color: #A5A5A5">Waste Collection Schedule</p>
            </template>
            <first-step
              ref="step1"
              @on-validated="onStepValidated"
            ></first-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              2
              <p style="color: #A5A5A5; width: 200px">WCO</p>
            </template>
            <second-step
              ref="step2"
              @on-validated="onStepValidated"
            ></second-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step3')">
            <template slot="label">
              3
              <p style="color: #A5A5A5; width: 200px">Delivery Order</p>
            </template>
            <third-step
              ref="step3"
              @on-validated="onStepValidated"
            ></third-step>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div> 
  </div>
</template>
<script>
import FirstStep from "../Vessel/Job/WasteCollection.vue";
import SecondStep from "../Vessel/Job/WCO.vue";
import ThirdStep from "../Vessel/Job/DeliveryOrder.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    getBack() {
      sessionStorage.removeItem("job-num-vessel");
      this.$router.push("/Vessel/Request");
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
      // console.log(model)
      // console.log(this.wizardModel)
    },
    wizardComplete() {
      swal("Good job!", "You clicked the finish button!", "success");
    }
  }
};
</script> -->